<template>
  <GmapMap
    :options="mapStyle"
    :center="center"
    :zoom="zoom"
    ref="googleMap"
    map-type-id="roadmap"
    style="width: 100%; height: 100%"
    @dragend="updateMap"
    @zoom_changed ="zoomChanged"
    @center_changed ="centerChanged"
    @click="clickMap"
    >
    <div v-if="paths.length > 0 && $route.query && $route.query.city">
      <gmap-polygon :paths="path.path" :editable="false"  :options="polygonOptions" v-for="path of paths" :key="path.id"></gmap-polygon>

    </div>

  <!-- google info window for properties -->
  <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
    <div v-if="selectedProperties.length > 0" style="max-height:10em" v-loading="hoverLoading">
      <div class="property-popup" v-for="property of selectedProperties" :key="property.int_propererty_id" @click="toModal(property)">
        <div class="image" v-if="property.covers && property.covers.length > 0">
          <img :src="property.covers[0]" alt="Placeholder image" style="max-height:75px;max-width:60px">
        </div>
        <div class="content">
          <div class="name-region">
            <span class="name">{{language === 'english' ? property.str_property_name_en : property.str_property_name_jp}}</span>
            <span>{{language === 'english' ? property.city.name : property.city.name_jp}}</span>
          </div>
          <div class="link">
            <span class="price">¥ {{property.rent}}</span>
          </div>
        </div>
      </div>
    </div>
  </gmap-info-window>

  <!-- google info window for nearby places -->
  <!-- <gmap-info-window :options="infoOptions" :position="nearbyInfoWindowPos" :opened="nearbyInfoWinOpen" @closeclick="nearbyInfoWinOpen=false">
    <p class="place-name">{{selectedPlace.name}}</p>
  </gmap-info-window> -->

  <!-- google marker for schools -->
  <!-- <div v-if="$store.state.search.includeSchool">
    <GmapMarker
        :key="m.id"
        v-for="m in nearBy.schools"
        :position="m.geometry.location"
        :clickable="true"
        :draggable="false"
        :icon="schoolIcon"
         @mouseover="hoverNearby(m)"
      />
  </div> -->

  <!-- google marker for restaurants -->
  <!-- <div v-if="$store.state.search.includeRestaurant">
    <GmapMarker
        :key="m.id"
        v-for="m in nearBy.restaurants"
        :position="m.geometry.location"
        :clickable="true"
        :draggable="false"
        :icon="restaurantIcon"
        @mouseover="hoverNearby(m)"
      />
  </div> -->

    <!-- google marker for train Station -->
  <!-- <div v-if="$store.state.search.includeTrainStation">
    <GmapMarker
        :key="m.id"
        v-for="m in nearBy.train_stations"
        :position="m.geometry.location"
        :clickable="true"
        :draggable="false"
        :icon="trainIcon"
        @mouseover="hoverNearby(m)"
      />
  </div> -->

  <!-- google marker for Bus Station -->
  <!-- <div v-if="$store.state.search.includeBusStation">
    <GmapMarker
        :key="m.id"
        v-for="m in nearBy.bus_stations"
        :position="m.geometry.location"
        :clickable="true"
        :draggable="false"
        :icon="busIcon"
        @mouseover="hoverNearby(m)"
      />
  </div> -->

<!-- when current zoom number smaller than 12, it will dispaly cluster, otherwise, it will only display markers -->
<div v-if="zoom < 12">
    <gmap-cluster
              :zoomOnClick="true"
              :minimumClusterSize=2
              :styles="clusterStyles"
            >
      <!-- google marker for properties -->
          <GmapMarker
            :key="index"
            v-for="(m, index) in properties.data"
            :position="{
              lat:parseFloat(m.int_latitude),
              lng:parseFloat(m.int_longitude)
            }"
            :clickable="true"
            :draggable="false"
            @mouseover="hover(m, index)"
            @click="hover(m, index)"
            :icon="icon"
            class="map-marker"
          />
      </gmap-cluster>
</div>
<div v-else>
   <GmapMarker
            :key="index"
            v-for="(m, index) in properties.data"
            :position="{
              lat:parseFloat(m.int_latitude),
              lng:parseFloat(m.int_longitude)
            }"
            :clickable="true"
            :draggable="false"
            @mouseover="hover(m, index)"
            @click="hover(m, index)"
            :icon="icon"
            class="map-marker"
          />
</div>



    <div slot="visible">
        <!-- <div class="school-bus-btns">
            <el-tooltip effect="light" content="Schools" placement="bottom">
                <el-button type="primary" size="mini" @click="showSchool" :class="$store.state.search.includeSchool ? 'active-btn' : ''"><i class="fas fa-school"></i></el-button>
            </el-tooltip>
            <el-tooltip effect="light" content="Restaurants" placement="bottom">
                <el-button type="primary" size="mini" @click="showRestaurant" :class="$store.state.search.includeRestaurant ? 'active-btn' : ''"><i class="fas fa-utensils"></i></el-button>
            </el-tooltip>
            <el-tooltip effect="light" content="Train Stations" placement="bottom">
                <el-button type="primary" size="mini" @click="showTrainStation" :class="$store.state.search.includeTrainStation ? 'active-btn' : ''"><i class="fas fa-train"></i></el-button>
            </el-tooltip>
            <el-tooltip effect="light" content="Bus Stops" placement="bottom">
                <el-button type="primary" size="mini" @click="showBusStation" :class="$store.state.search.includeBusStation ? 'active-btn' : ''"><i class="fas fa-bus"></i></el-button>
            </el-tooltip>
        </div> -->
        <div>
          <el-checkbox v-model="$store.state.search.searchAsChange" class="map-checkbox">{{'Search as I move the map' | language}}</el-checkbox>
        </div>
    </div>
  </GmapMap>
</template>

<script>
import config from '../../../config'
import propertyService from '../../services/propertyService'
import utilsService from '../../services/utilsService'
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
    name: 'app',
    data: function() {
        return {
            infoOptions: {
                pixelOffset: {
                    width: 0,
                    height: -40
                }
            },
            mapStyle: config.MAP_STYLE,
            zoomOnClick:true,
            infoContent: '',
            infoWindowPos: null,
            infoWinOpen: false,
            currentMidx: null,
            zoomControl: true,
            schoolIcon: {
                url: config.API_URL + '/img/school.png',
                size: { width: 25, height: 25, f: 'px', b: 'px' },
                scaledSize: { width: 25, height: 25, f: 'px', b: 'px' }
            },
            restaurantIcon: {
                url:config.API_URL + '/img/restaurant.png',
                size: { width: 25, height: 25, f: 'px', b: 'px' },
                scaledSize: { width: 25, height: 25, f: 'px', b: 'px' }
            },
            trainIcon: {
                url: config.API_URL + '/img/train.png',
                size: { width: 25, height: 25, f: 'px', b: 'px' },
                scaledSize: { width: 25, height: 25, f: 'px', b: 'px' }
            },
            busIcon: {
                url:config.API_URL + '/img/bus.png',
                size: { width: 25, height: 25, f: 'px', b: 'px' },
                scaledSize: { width: 25, height: 25, f: 'px', b: 'px' }
            },
            nearbyInfoWindowPos:null,
            nearbyInfoWinOpen:false,
            nearbyCurrentMidx:null,
            icon: {
                url: config.API_URL + '/img/jhf-marker-list.png',
                size: { width: 30, height: 40, f: 'px', b: 'px' },
                scaledSize: { width: 30, height: 40, f: 'px', b: 'px' },
            },
            mapCenter: {
              lat:this.$store.state.property.center.lat,
              lng:this.$store.state.property.center.lng
            },
            maxZoom: 22,
            displayClusterWindow: false,
            selectedProperties:[],
            selectedPlace:{},
            hoverLoading: false,
            polygonOptions: {
                fillColor: '#b2d9f7',
                fillOpacity: 0,
                strokeOpacity: 1,
                strokeColor: '#000000',
                strokeWeight: 4
            },
            clusterStyles: [
            {
                textColor: '#FFF',
                url: 'https://i.ibb.co/NsFr2vy/jhf-marker-33.png',
                height: 32.2,
                width: 32,
                'fontFamily':'Proxima Nova',
                'fontSize':'16px',
            },
            {
                textColor: '#FFF',
                url: 'https://i.ibb.co/LZXpmGK/jhf-marker-46.png',
                height: 46,
                width: 46,
                'fontFamily':'Proxima Nova',
                'fontSize':'16px',
            },
            {
                textColor: '#FFF',
                url: 'https://i.ibb.co/kQ2zFwR/jhf-marker-64.png',
                height: 64,
                width: 64,
                'fontFamily':'Proxima Nova',
                'fontSize':'16px',
            }
          ],
        }
    },
    computed: {
      ...mapState({
        properties: (state) => {
          return state.property.maps
        },
        paths:(state) => {
          return state.property.paths
        },
        center:(state) => {
          return state.property.center
        },
        zoom:(state) => {
          return state.property.currentZoom
        },
        nearBy:(state) => {
          return state.property.nearBy
        },
        language:(state) => {
          return state.general.language
        }
      }),
      // center(){
      //   return this.$store.getters['property/center']
      // }
    },
  mounted () {
    // At this point, the child GmapMap has been mounted, but
    // its map has not been initialized.
    // Therefore we need to write mapRef.$mapPromise.then(() => ...)
  },
  created() {
  },
  methods: {
      clickMap(){
        this.infoWinOpen = false;
      },
      hover(marker,index) {
            this.nearbyInfoWinOpen = false
            if (marker && marker.int_property_id) {
                this.infoWindowPos = {
                  lat:parseFloat(marker.int_latitude),
                  lng:parseFloat(marker.int_longitude)
                };
                this.hoverLoading = true
                const params = {
                  lat: marker.int_latitude,
                  lng: marker.int_longitude
                }
                propertyService.getByCoordinates(params)
                .then(resp => {
                  _.forEach(resp.data,function(property){
                    property.rent = property.price > 0 && !property.bit_inquiry && !property.bit_inquiry_all ? utilsService.kFormatter(property.price) : 'Please Inquire'
                    property.covers = property.building && property.building.images.length > 0 ? property.building.images : utilsService.defaultCover()
                  })
                  this.selectedProperties = resp.data
                })
                .finally(() => {
                  this.hoverLoading = false
                })
                //check if its the same marker that was selected if yes toggle
                if (this.currentMidx == index) {
                  this.infoWinOpen = !this.infoWinOpen
                } else {
                  this.infoWinOpen = true
                  this.currentMidx = index
                }
            }

      },

      hoverNearby(marker){
        this.infoWinOpen = false
        this.nearbyInfoWindowPos = marker.geometry.location
        //check if its the same marker that was selected if yes toggle
          if (this.nearbyCurrentMidx == marker.id) {
            this.nearbyInfoWinOpen = !this.nearbyInfoWinOpen
          } else {
            this.nearbyInfoWinOpen = true
            this.nearbyCurrentMidx = marker.id
          }
          this.selectedPlace = marker

      },
      centerChanged(e){
          this.mapCenter = {
            lat:e.lat(),
            lng:e.lng()
          };
      },
      updateMap(){
         const bound = this.$refs.googleMap.$mapObject.getBounds()
          const param = {
            northEast:{
              lat: bound.getNorthEast().lat(),
              lng: bound.getNorthEast().lng()
            },
            southWest:{
              lat: bound.getSouthWest().lat(),
              lng: bound.getSouthWest().lng()
            }
          }
          if (this.$store.state.search.searchAsChange) {
              const query = {
                lat: this.mapCenter.lat,
                lng: this.mapCenter.lng,
                zoom: this.$store.state.property.currentZoom
              }
              const bound = this.$refs.googleMap.$mapObject.getBounds()
              this.$store.commit('search/set_map_query',query);
              this.$router.push({...this.$route,query:{...this.$store.state.search.query,bounds:JSON.stringify(param)}});
          }
      },
      zoomChanged(e){
          this.$store.commit('property/set_current_zoom',e)
      },
      showSchool(){
        this.$store.commit('search/set_include_school',this.$store.state.search.includeSchool ? 0 : 1)
      },
      showRestaurant(){
        this.$store.commit('search/set_include_restaurant', this.$store.state.search.includeRestaurant ? 0 : 1)
      },
      showTrainStation(){
        this.$store.commit('search/set_include_train_station', this.$store.state.search.includeTrainStation ? 0 : 1)
      },
      showBusStation(){
        this.$store.commit('search/set_include_bus_station', this.$store.state.search.includeBusStation ? 0 : 1)
      },
      toModal(property){
        this.$router.push({ name: 'Property', params: { id: property.int_property_id } })
      }
  }
}
</script>

<style lang="scss">
    .gm-fullscreen-control {
      display: none;
    }

    .gm-svpc {
      display: none;
    }

    .gm-style {
        .gm-style-iw-c {
            border-radius: 4px;
            padding: 0 .5em !important;
        }
    }

    .mapActive {
      background: red !important;
      color: white !important;
    }

    .school-bus-btns {
      position: absolute;
      top: 20px;
      right: 10px;

      .el-button {
        &.active-btn {
          background-color: #9b0012 !important;
          border-color: #9b0012 !important;
        }
      }

      .fas {
          padding: 0;
      }
    }

    .place-name {
        margin: 0;
        padding: 1em 0 0 0;
        font-weight: 500;
    }

    .map-checkbox {
        position: absolute !important;
        top: 1em;
        right: 1em;
        background: $white;
        padding: 0 .25em;
        border-radius: 2px;
        color: $dark-grey !important;
    }

    .property-popup {
        display: flex;
        border-top: 1px solid rgba($alternate-color, .1);
        padding: .5em 0 0 0;
        margin-top: .5em;
        cursor: pointer;

        &:first-child {
            border-top: none;
            margin-top: 0;
        }

        .image {
            flex: 0 0 60px;
            width: 60px;
            text-align: center;
            margin: 0 .5em 0 0;
        }

        .content {
            display: flex;
            flex-direction: column;
            flex: 1 1 auto;
            justify-content: space-between;
            min-width: 120px;
            max-width: 120px;
        }

        .name-region {
            span {
                display: inline-block;
                width: 100%;

                &.name {
                    font-weight: 500;
                }
            }
        }

        .link {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-self: end;
            padding-top: .5em;

            .price {
                color: green;
                font-weight: 500;
            }
        }
    }

  @media (max-width: 767px) {
    .school-bus-btns {
      .el-button+.el-button {
        margin-left: 3px;
      }
    }

    .gm-style-mtc {
      div {
        height: 28px !important;
        font-size: 12px !important;
        padding: 0px 14px !important;
      }
    }

    .gmnoprint.gm-bundled-control {
      .gmnoprint {
        div {
          width: 25px !important;
          height: 51px !important;

          button {
            width: 25px !important;
            height: 25px !important;

            img {
              height: 10px !important;
              width: 10px !important;
            }
          }

          div {
            width: 16px !important;
            height: 1px !important;
          }
        }
      }
    }
  }
</style>

